"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconValidationMethodBase = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class FalconValidationMethodBase extends journey_services_1.ValidationMethodBase {
    getInteraction(context) {
        if (context.interaction) {
            return context.interaction;
        }
        const pageContext = context;
        return pageContext.engine && pageContext.engine.getInteraction();
    }
}
exports.FalconValidationMethodBase = FalconValidationMethodBase;
//# sourceMappingURL=FalconValidationMethodBase.js.map